import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';

var _ref = React.createElement(
	'div',
	null,
	React.createElement(
		'h2',
		null,
		'A PAGE'
	)
);

var Paginate = function (_Component) {
	_inherits(Paginate, _Component);

	function Paginate() {
		_classCallCheck(this, Paginate);

		return _possibleConstructorReturn(this, (Paginate.__proto__ || Object.getPrototypeOf(Paginate)).apply(this, arguments));
	}

	_createClass(Paginate, [{
		key: 'render',
		value: function render() {

			return _ref;
		}
	}]);

	return Paginate;
}(Component);

export default Paginate;